import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const SearchIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 10.05 10">
      <path
        d="M8.64,9a.36.36,0,0,1-.256-.1L6.317,6.828a3.857,3.857,0,1,1,.512-.512L8.9,8.383A.361.361,0,0,1,8.64,9ZM3.857.723a3.134,3.134,0,0,0-1.22,6.021A3.139,3.139,0,0,0,6.745,5.077a3.126,3.126,0,0,0-.672-3.435A3.118,3.118,0,0,0,3.857.723Z"
        transform="translate(0.5 0.5)"
        fill={props.color || theme.palette.gray.main}
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </SvgIcon>
  );
};
